export default __webpack_public_path__ + "static/media/managepr_navicon.2a6ed9d7.svg";